var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"container"},[(_vm.isAuthenticated)?_c('div',{staticClass:"container-main"},[_c('Navigation',{staticClass:"navigation"}),_c('div',{staticClass:"main"},[_c('router-view')],1)],1):_c('div',[_c('v-app-bar',[_c('h1',{staticClass:"title"},[_vm._v("Phantom-Shares")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }